import { cn } from "ui";

export interface PageHeaderProps {
  title: React.ReactNode;
  description?: string;
  actions?: React.ReactNode;
  withoutBorder?: boolean;
  className?: string;
}

export function PageHeader({
  title,
  description,
  actions,
  withoutBorder = false,
  className,
}: PageHeaderProps) {
  return (
    <div
      className={cn(
        "flex flex-wrap items-center gap-4",
        !withoutBorder && "border-b border-foundations-subtle pb-3",
        className
      )}
    >
      <div className="flex flex-1 flex-col gap-2">
        <h1 className="text-lg font-medium text-foundations-boldest">
          {title}
        </h1>
        {description && (
          <p className="text-sm text-foundations-subtle">{description}</p>
        )}
      </div>

      {actions}
    </div>
  );
}
